/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type LoyaltyRequestStatusEnum = 0 | 1 | 2;

export const LoyaltyRequestStatusEnum = {
    NUMBER_0: 0 as LoyaltyRequestStatusEnum,
    NUMBER_1: 1 as LoyaltyRequestStatusEnum,
    NUMBER_2: 2 as LoyaltyRequestStatusEnum
};

